import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LangContext";
import { EQUIPMENT } from "../../lib/data";
import { Reveal, Tag } from "./Reveal";

export const Equipment = () => {
  const { t, lang } = useLang();
  return (
    <section id="equipment" className="relative bg-brand-light py-24 md:py-32" data-testid="equipment">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Tag>{t.equipment.tag}</Tag>
          <h2 className="mt-5 font-display font-semibold text-brand-navy text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[1.02]">
            {t.equipment.title}
          </h2>
          <p className="mt-6 max-w-2xl text-slate-600 text-base md:text-lg leading-relaxed">{t.equipment.subtitle}</p>
        </Reveal>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {EQUIPMENT.map((e, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                className="group h-full rounded-xl bg-white border border-slate-200 overflow-hidden shadow-sm hover:shadow-xl transition-shadow"
                data-testid={`equipment-card-${i}`}
              >
                <div className="relative aspect-square overflow-hidden bg-white p-5">
                  <img
                    src={e.img}
                    alt={e[lang]}
                    loading="lazy"
                    className="h-full w-full object-contain transition-transform duration-700 group-hover:scale-[1.06]"
                  />
                  <div className="absolute inset-x-0 bottom-0 h-1 bg-brand-azure scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
                </div>
                <div className="px-4 py-4 border-t border-slate-100">
                  <div className="font-display text-base font-medium text-brand-navy leading-tight">{e.it}</div>
                  <div className="font-condensed text-xs uppercase tracking-[0.12em] text-slate-400 mt-0.5">{e.en}</div>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
